<template>
    <oc-page title="Choose an account">
        <div class="auth-box account-list" id="choose-account">

            <template v-if="$root.customerLogo !== false">
                <img :src="$root.customerLogo" alt="Customer logo" class="customer-logo" />
                <div class="hr"></div>
            </template>

            <oc-flash-messages />

            <h4 class="section-title">Choose an Account</h4>
            <div class="hr mb-5"></div>

            <div v-for="(user, index) in $root.authInfo.users" class="auth-account-box" :class="'object-color-'+ getColor(index)" @click="selectUser(user, index)">
                <div class="beacon-container beacon-big">
                    <div class="beacon-loadingd auth-beacon">
                        <i class="glyphicon glyphicon-user user-icon"></i>
                        <div class="auth-beacon-border"></div>
                    </div>
                </div>
                <div class="auth-account-info">
                    <div class="pull-left">
                        <p class="m-0 account-username" :title="user.username" :class="{center: !user.email}"><b>{{user.username}}</b></p>
                        <p class="m-0 account-email" :title="user.email" v-if="user.email"><i>{{user.email}}</i></p>
                    </div>
                    <i class="pull-right glyphicon glyphicon-chevron-right arrow-right">&nbsp;</i>
                    <span class="pull-right text-right account-status">Signed out</span>
                </div>
            </div>

            <div class="hr mt-5"></div>

            <oc-button-input class="mt-3 btn btn-default btn-block" @click="addAccount">
                <oc-icon type="user-plus" />
                Add another account
            </oc-button-input>

            <oc-button-input class="mt-3 btn btn-default btn-block" @click="removeAccount">
                <oc-icon type="user-times" />
                Remove an account
            </oc-button-input>

        </div>
    </oc-page>
</template>

<script>
import AuthStateMixin from '@/mixins/AuthStateMixin'
import AccountListMixin from '@/pages/auth/mixins/AccountListMixin'

export default {
    name: "choose",
    mixins: [AuthStateMixin, AccountListMixin],
    methods: {
        selectUser(user, colorIndex) {
            this.$router.push({
                path: '/enter-password',
                query: {
                    username: user.username,
                    color: this.colors[colorIndex]
                }
            })
        },
        addAccount() {
            this.$router.push({
                path: '/login',
                query: {
                    force: 1
                }
            })
        },
        removeAccount() {
            this.$router.push({
                path: '/remove-account'
            })
        }
    }
}
</script>
